export default "__VITE_ASSET__9c9b07a2__"